import { render, staticRenderFns } from "./vehicleDisplay.vue?vue&type=template&id=07b8fc94&scoped=true&"
import script from "./vehicleDisplay.vue?vue&type=script&lang=js&"
export * from "./vehicleDisplay.vue?vue&type=script&lang=js&"
import style0 from "./vehicleDisplay.vue?vue&type=style&index=0&id=07b8fc94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8fc94",
  null
  
)

export default component.exports